<template>
    <div v-if="basketSelect">
        <template v-if="editMode">
            <label class="h4" :for="'shipping-country-select' + _uid">{{ $translate('Ceres::Template.headerSelectShippingCountry') }}
                <i v-if="isDisabled"
                   :data-title="$translate('Ceres::Template.headerChangeDeliveryCountry')"
                   :aria-label="$translate('Ceres::Template.headerChangeDeliveryCountry')"
                   v-tooltip="isDisabled"
                   style="font-size: 80%"
                   class="fa fa-info-circle"></i>
            </label>
            <select v-if="localization.shippingCountries.length > 1"
                    :id="'shipping-country-select' + _uid"
                    class="form-control"
                    @change="setShippingCountry($event.target.value)"
                    :disabled="isDisabled">
                <option v-for="shippingCountry in highlightedShippingCountriesMinimal"
                        :value="shippingCountry.id"
                        :disabled="isDisabled"
                        :selected="basket.shippingCountryId == shippingCountry.id"
                        :key="shippingCountry.id">
                    {{shippingCountry.currLangName}}
                </option>
                <option disabled>---</option>
                <option v-for="shippingCountry in sortedCountriesWithoutHighlighted"
                        :value="shippingCountry.id"
                        :disabled="isDisabled"
                        :selected="basket.shippingCountryId == shippingCountry.id"
                        :key="shippingCountry.id">
                    {{shippingCountry.currLangName}}
                </option>
            </select>
            <div v-else>
                {{ getCountryName(localization.shippingCountryId) }}
            </div>
        </template>
        <template v-else>
            <div class="d-flex justify-content-between cursor-pointer" @click="editMode = true">
                {{ $translate('Ceres::Template.headerSelectShippingCountry') }}
                <span>{{ getCountryName(localization.shippingCountryId) }}</span>
            </div>
        </template>
    </div>
    <div v-else>
        <ul
            class="row"
        >
            <li
                v-for="shippingCountry in showAll ? sortedCountries : highlightedShippingCountries"
                :key="shippingCountry.id"
                class="col-6 col-sm-4 px-0"
                :class="{'active': basket.shippingCountryId == shippingCountry.id, 'is-disabled': isDisabled}"
            >
                <a
                    v-tooltip="isDisabled"
                    class="nav-link"
                    data-toggle="collapse"
                    href="#countrySettings"
                    :disabled="isDisabled"
                    data-boundary="window"
                    :data-title="$translate('Ceres::Template.headerChangeDeliveryCountry')"
                    :aria-label="$translate('Ceres::Template.headerChangeDeliveryCountry')"
                    @click="setShippingCountry(shippingCountry.id)"
                >

                    <i :class="'flag-icon flag-icon-' + shippingCountry.isoCode2.toLowerCase()"/>
                    {{ shippingCountry.currLangName }}
                </a>
            </li>
        </ul>
        <div
            v-if="!showAll"
            class="mb-3 pt-4 border-top d-flex justify-content-center mt-3"
        >
            <button
                class="btn btn-outline-primary"
                @click.prevent.stop="showAll = true"
            >
                {{ $translate('modeherz::HeaderClient.headerShowAllCountries') }}
            </button>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import { removeUrlParam } from '../../../app/services/UrlService';

    export default {
        props:
            {
                disableInput: Boolean,
                highlightedCountryCodes: {
                    type: Array,
                    required: true,
                },
                basketSelect: {
                    type: Boolean,
                    default: false,
                },
            },
        data() {
            return {
                showAll: (this.highlightedCountryCodes ?? []).length === 0,
                editMode: false,
            };
        },
        mounted() {
            removeUrlParam('openBasketPreview');
        },
        computed:
            {
                isDisabled() {
                    return !!this.basket.customerInvoiceAddressId || !!this.basket.customerShippingAddressId || this.disableInput;
                },
                ...mapState({
                    localization: state => state.localization,
                    basket: state => state.basket.data,
                }),
                ...mapGetters([
                    'getCountryName',
                ]),
                sortedCountries() {
                    return [...this.localization.shippingCountries].sort((a, b) => a.currLangName.localeCompare(b.currLangName));
                },
                sortedCountriesWithoutHighlighted() {
                    return this.sortedCountries.filter(c => !((this.highlightedCountryCodes?.includes(c.isoCode2) && !c.currLangName.includes(',') ||
                        this.basket.shippingCountryId === c.id)));
                },
                highlightedShippingCountries() {
                    return this.sortedCountries.filter(c => (this.highlightedCountryCodes?.includes(c.isoCode2) && !c.currLangName.includes(',')) ||
                        this.basket.shippingCountryId === c.id);
                },
                highlightedShippingCountriesMinimal() {
                    const minimumCodes = this.highlightedCountryCodes?.slice(0, 5) ?? [];
                    return this.sortedCountries.filter(c => (minimumCodes.includes(c.isoCode2) && !c.currLangName.includes(',')) ||
                                   this.basket.shippingCountryId === c.id)
                               .sort((a, b) => minimumCodes.indexOf(a.isoCode2) - minimumCodes.indexOf(b.isoCode2));
                },
            },
        methods:
            {
                setShippingCountry(id) {
                    if (!this.isDisabled) {
                        this.$store.dispatch('selectShippingCountry', {
                            shippingCountryId: id,
                            openBasketPreview: false,
                        });
                    }
                },
            },
    };
</script>
